/* =====================================================================
   RYNOR – product cards: less to download until the shopper reaches for a card

   1) Photo 3 loads when the shopper shows interest in that card
      Photos 1 and 2 load exactly as before (photo 2 is ready the moment a card is hovered or
      swiped). Photo 3 starts loading when:
        - a mouse moves onto the card (computers)
        - the card's photos start being swiped sideways (phones and tablets – scrolling the page
          past a card doesn't count)
        - its arrows or dots are pressed, or the keyboard moves into it
      snippets/product-loop.liquid writes photo 3 with its sources parked in data-rynor-srcset /
      data-rynor-src, and this puts them back. Same photo, same full list of sizes, so it's just
      as sharp on big screens. The card slider in theme.js then waits for it like any other photo.

   2) A card's hidden add-to-cart form is built when its + is pressed
      It used to be in the page on every card (about 1.2 KB each, always hidden). Nothing used it –
      the + adds with the variant id on the button (assets/cc-size-overlay.js) – so it's now copied
      from one shared copy (snippets/rynor-card-form.liquid) the first time a card's + is pressed,
      for anything that might still look for it.

   Loaded on every page by layout/theme.liquid (deferred). Cards added later (filters, infinite
   scroll, search, recommendations) work too: everything listens on the window.
   ===================================================================== */
(function () {
  'use strict';

  if (window.RynorCards) return;

  var CARD = 'article[data-card], .product-loop__item';
  var SLIDER = '.rynor-card-slider';
  var LATER = 'img[data-rynor-srcset], img[data-rynor-src]';
  var CONTROLS = '.rynor-card-arrow, .rynor-card-dot';
  var PLUS = 'button[data-open-size-overlay][data-quick-add]';
  var LISTEN = { capture: true, passive: true };

  function closest(el, selector) {
    return el && el.nodeType === 1 && el.closest ? el.closest(selector) : null;
  }

  /* ---------- 1) photo 3 ---------- */

  function wakePhoto(img) {
    var srcset = img.getAttribute('data-rynor-srcset');
    var src = img.getAttribute('data-rynor-src');
    img.removeAttribute('data-rynor-srcset');
    img.removeAttribute('data-rynor-src');

    /* the card slider (theme.js) may already have "pre-loaded" this photo while it had nothing to
       load: forget that, so the slider waits for the real photo before sliding to it */
    img._rynorWarmPromise = null;
    if (img.dataset) delete img.dataset.rynorWarmState;

    /* start right away, even though the photo is tucked away inside the slider */
    try { img.loading = 'eager'; } catch (e) {}
    img.setAttribute('loading', 'eager');

    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
  }

  function wakeCard(el) {
    var card = closest(el, CARD) || closest(el, SLIDER);
    if (!card) return;
    var imgs = card.querySelectorAll(LATER);
    for (var i = 0; i < imgs.length; i++) wakePhoto(imgs[i]);
  }

  /* computers: the mouse moves onto a card (fingers are handled further down) */
  function onPointerOver(e) {
    if (e.pointerType === 'touch') return;
    wakeCard(e.target);
  }

  /* keyboard: moving into a card (a tap or click that focuses a link doesn't count) */
  function onFocusIn(e) {
    var keyboard = true;
    try { keyboard = e.target.matches(':focus-visible'); } catch (err) {}
    if (keyboard) wakeCard(e.target);
  }

  /* phones and tablets: the card's photos start moving sideways (a swipe), not up and down (a
     scroll). Same test the card slider uses (theme.js), so photo 3 is on its way before the
     slider starts moving. */
  var touch = null;

  function onTouchStart(e) {
    touch = null;
    if (!e.touches || e.touches.length !== 1) return;
    var slider = closest(e.target, SLIDER);
    if (!slider || !slider.querySelector(LATER)) return;
    touch = { slider: slider, x: e.touches[0].clientX, y: e.touches[0].clientY };
  }

  function onTouchMove(e) {
    if (!touch || !e.touches || e.touches.length !== 1) return;
    var dx = Math.abs(e.touches[0].clientX - touch.x);
    var dy = Math.abs(e.touches[0].clientY - touch.y);
    if (dx > 10 && dx >= dy * 0.9) {
      wakeCard(touch.slider);
      touch = null;
    } else if (dy > 10 && dy > dx * 1.1) {
      touch = null;
    }
  }

  function onTouchEnd() {
    touch = null;
  }

  /* ---------- 2) the hidden add-to-cart form ---------- */

  function setValue(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) return;
    input.value = value;
    input.setAttribute('value', value);
  }

  function cartConfig() {
    var el = document.getElementById('cart-config');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  }

  function buildForm(plus) {
    var card = closest(plus, CARD);
    var copy = document.getElementById('rynor-card-form');
    if (!card || !copy || !copy.content) return;
    if (card.querySelector('form.shopify-product-form')) return; /* already built */

    var productId = plus.getAttribute('data-product-id') || card.getAttribute('data-product-id') || '';
    var variantId = plus.getAttribute('data-default-variant') || '';
    if (!productId || !variantId) return;

    var fragment = copy.content.cloneNode(true);
    var form = fragment.querySelector('form');
    if (!form) return;

    form.id = 'product_form_' + productId;
    setValue(form, 'id', variantId);
    setValue(form, 'product-id', productId);
    var section = closest(card, '.shopify-section');
    setValue(form, 'section-id', section && section.id ? section.id.replace(/^shopify-section-/, '') : '');

    /* the same click the theme gives every .js-ajax-submit when the page loads (assets/cart.js) */
    var submit = form.querySelector('.js-ajax-submit');
    if (submit) {
      submit.setAttribute('data-ajax-cart-bound', 'true');
      submit.addEventListener('click', function (e) {
        e.preventDefault();
        var W = window.WAU;
        if (W && W.AjaxCart && typeof W.AjaxCart.addToCart === 'function') {
          W.AjaxCart.addToCart(form, form, cartConfig(), false, false);
        }
      });
    }

    card.appendChild(fragment);
  }

  function plusFrom(e) {
    return closest(e.target, PLUS);
  }

  /* ---------- listening ---------- */

  /* any pointer: arrows/dots wake photo 3 before the slider reacts; + builds the form before
     assets/cc-size-overlay.js adds to the cart */
  function onPress(e) {
    if (closest(e.target, CONTROLS)) wakeCard(e.target);
    var plus = plusFrom(e);
    if (plus) buildForm(plus);
  }

  function onKey(e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var plus = plusFrom(e);
    if (plus) buildForm(plus);
  }

  if (window.PointerEvent) {
    window.addEventListener('pointerover', onPointerOver, LISTEN);
    window.addEventListener('pointerdown', onPress, LISTEN);
  } else {
    window.addEventListener('mouseover', onPointerOver, LISTEN);
    window.addEventListener('mousedown', onPress, LISTEN);
    window.addEventListener('touchstart', onPress, LISTEN);
  }
  window.addEventListener('focusin', onFocusIn, LISTEN);
  window.addEventListener('touchstart', onTouchStart, LISTEN);
  window.addEventListener('touchmove', onTouchMove, LISTEN);
  window.addEventListener('touchend', onTouchEnd, LISTEN);
  window.addEventListener('touchcancel', onTouchEnd, LISTEN);
  window.addEventListener('keydown', onKey, true);
  /* last safety net for the + (anything that clicks it without a press first) */
  window.addEventListener('click', function (e) {
    var plus = plusFrom(e);
    if (plus) buildForm(plus);
  }, true);

  window.RynorCards = { wake: wakeCard, buildForm: buildForm };
})();
